import { ProductCode } from '~/types'

export const ProductRoutes: Record<string | number, string> = {
	zencare: '/zencare',
	flexicare: '/flexicare',
	primecare: '/primecare',
	gadget: '/gadget',
	[ProductCode.TRAVEL_ALLIANZ]: '/travel-cover',
	[ProductCode.MINI_COMPREHENSIVE]: '/mini-comprehensive',
	[ProductCode.THIRD_PARTY]: '/third-party',
	[ProductCode.COMPREHENSIVE_AUTO]: '/comprehensive-cover'
}

export enum NAVLINKS {
	sendcare = 'sendcare',
	sendcareWaitlist = 'sendcare-waitlist',
	about = 'about',
	contact = 'contact',
	blog = 'blog',
	faqs = 'faqs',
	careers = 'careers',
	privacyPolicy = 'privacy-policy',
	termsAndConditions = 'terms-and-conditions'
}

export function setProductRoute(group_id: string, code_name: number) {
	if (ProductRoutes?.[group_id]) {
		return ProductRoutes[group_id]
	}
	if (ProductRoutes?.[code_name]) {
		return ProductRoutes[code_name]
	}
	return '/'
}
